export default (state = [], action) => {
  switch (action.type) {
    case 'GET_SEARCH_RESULTS': {
      return action.payload;
    }
    default:
      return state;
  }
};
